import { createContext, useState, useContext } from 'react';

export const WorkmateTimeinContext = createContext({
  openWorkmateTimein: () => {},
});

export const WorkmateTimeinProvider = ({ children }) => {
  const [isWorkmateTimeinOpen, setIsWorkmateTimeinOpen] = useState(false);

  const openWorkmateTimein = () => {
    setIsWorkmateTimeinOpen(true);
  };

  const closeWorkmateTimein = () => {
    setIsWorkmateTimeinOpen(false);
  };

  return (
    <WorkmateTimeinContext.Provider 
      value={{ 
        isWorkmateTimeinOpen, 
        openWorkmateTimein, 
        closeWorkmateTimein 
      }}
    >
      {children}
    </WorkmateTimeinContext.Provider>
  );
};

export const useWorkmateTimein = () => useContext(WorkmateTimeinContext); 